import WWBagelsProduct from 'models/WWBagelsProduct'

export const packagingInitialState = {
  category: WWBagelsProduct.category,
  subCategory: WWBagelsProduct.subCategory,
  Size: WWBagelsProduct.Size,
  WholeWheatCert: WWBagelsProduct.WholeWheatCert,
}
